import axios from 'axios';

/**
 *
 * @name 进行Axios的Post请求
 * @param url 请求地址
 * @param data 数据
 */
const postRequest = async (url: string, data: any) => {
  try {
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 *
 * @name newsLetter接口请求
 * @description 对参数进行包装为表单数据后发起表单请求
 * @param locale 当前界面语言，目前只支持ja、en
 * @param email 邮箱
 */
const requestNewsLetter = async ({ locale, email }: { locale: string; email: string }) => {
  const url =
    locale === 'ja'
      ? 'https://23e25d8b.sibforms.com/serve/MUIFAPQ9Yby85QImQjB9rorFBRNyvuTEJUWW9MTnZyNkTPrUQB2S8u6TkXPC743Ey0kFWMTOfOk8J4gRgRRw6VWEsUDpW3QJJwD6ty8W5uhVEVha85FsznEzFRWfVbXY3VF3Jd73TZAADK_wUM9IM8ek1yEOrVMbqUd9FeTyi846kPEgPEdyOC9u57jJsX0ImxmpOoeB0Q0rjqfD'
      : 'https://23e25d8b.sibforms.com/serve/MUIFABNKb9_nyGy8p9t37hl7IEbDx4BsiECZ9sq_OAf7Fb2maeakhFHlnUL7nmvzKbHY8-pfrseO9tzpmBCgJSZ9LxChed_qh68O-6l41BDkUo8K5iK8zyJVWmB2iWYc1EeLSpx2Z7Nq2naJ1O02GQYiZJr-WXqaxndvRJSl923VGBtEy4omNwU9SfXzpdKneM6O2alB9AdAbye7';

  try {
    const formData = new FormData();
    const formValues = {
      EMAIL: email,
      locale,
      email_address_check: '',
      NEWSLETTER: 1,
    };
    // 添加表单字段和值
    for (const key in formValues) {
      formData.append(key, formValues[key]);
    }

    const res = await postRequest(`${url}?isAjax=1`, formData);
    return { isSuc: true, data: res };
  } catch (error) {
    return { isSuc: false };
  }
};

export { requestNewsLetter };
